module.exports = __webpack_public_path__ + "img/salmon.a5c45969.png";